// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated{
    background: #f7f7f7;
    position: relative;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(0, 0, 0,.1) inset;
    border-radius: 3px;
}
.small-text{
    display: block;
    padding: 0.5em 1em;
    position: relative;
    z-index: 1;
    font-size: 20px;
    font-weight: 400;
}
.blue-bar{
    background-color: rgb(0, 159, 227);
    /* width: 50%; */
    position: absolute;
    height: 100%;
    display: block;
    top: 0;
    border-radius: 3px;
}
.leftt{
    margin:auto;
   
}
.container-six {
    display: grid;
    grid-template-columns: repeat(5,1fr);
    /* justify-content: space-around;
    flex-wrap: wrap; */
    margin-bottom: 50px;
}

.box-six {
    flex-basis: 22%;
    text-align: center;
    margin: 5px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.logo-six {
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
}
.box-six:hover{
    transform: scale(1.03) ;
    transition: transform 0.2s;
    background-color: whitesmoke;
}

.name {
    font-size: 16px;
}
/* Add these styles to your CSS file */

.popup-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    text-align: center;
}
@media(max-width:'600px'){
    .popup-box {
        padding-left: 0px;
        padding-right: 0px;
        width:100%
    } 
}

.popup-logo {
    width: 100px;
    /* Adjust the width as needed */
    height: 100px;
    /* Adjust the height as needed */
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
}

/* Style for the email input */
.popup-box input {
    /* width: 90%; */
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Style for the subscribe button */
.popup-box button {
    padding: 10px 20px;
    background-color: orange;
    color: #fff;
    border: none;
    border-radius: 4px;
    margin-top: 10px;
    cursor: pointer;
}
.close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
    color: #333;
}
@media (max-width: 1000px) {
    .left-6{
        width: 100%;
    }
}
@media (max-width: 900px) {
    .container-six{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width: 500px){
    .container-six{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width: 350px) {
    .container-six{
        grid-template-columns: repeat(1,1fr);
    }
}

.popup-wrapper {
    position: fixed; /* Make the wrapper fixed so it stays in place */
    bottom: -150px; /* Position it at the bottom of the screen */
    left: 0; /* Align it to the left edge */
    width: 100%; /* Make sure it spans the full width of the screen */
    display: flex; /* Center the popup horizontally */
    justify-content: center; /* Center horizontally */
    align-items: baseline;
  }
  
  .popup-box {
    position: relative; /* Position relative within the wrapper */
    background: white; /* Ensure background is white or appropriate */
    border-radius: 8px; /* Optional: add some border radius for styling */
    padding: 20px; /* Adjust padding as needed */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Optional: add shadow for better visibility */
  }`, "",{"version":3,"sources":["webpack://./src/Home/Six.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,MAAM;IACN,kBAAkB;AACtB;AACA;IACI,WAAW;;AAEf;AACA;IACI,aAAa;IACb,oCAAoC;IACpC;sBACkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;AACA,sCAAsC;;AAEtC;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,eAAe;IACf,WAAW;AACf;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI,eAAe,EAAE,gDAAgD;IACjE,cAAc,EAAE,4CAA4C;IAC5D,OAAO,EAAE,8BAA8B;IACvC,WAAW,EAAE,oDAAoD;IACjE,aAAa,EAAE,kCAAkC;IACjD,uBAAuB,EAAE,wBAAwB;IACjD,qBAAqB;EACvB;;EAEA;IACE,kBAAkB,EAAE,yCAAyC;IAC7D,iBAAiB,EAAE,8CAA8C;IACjE,kBAAkB,EAAE,iDAAiD;IACrE,aAAa,EAAE,6BAA6B;IAC5C,2CAA2C,EAAE,+CAA+C;EAC9F","sourcesContent":[".animated{\n    background: #f7f7f7;\n    position: relative;\n    margin-bottom: 12px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0,.1) inset;\n    border-radius: 3px;\n}\n.small-text{\n    display: block;\n    padding: 0.5em 1em;\n    position: relative;\n    z-index: 1;\n    font-size: 20px;\n    font-weight: 400;\n}\n.blue-bar{\n    background-color: rgb(0, 159, 227);\n    /* width: 50%; */\n    position: absolute;\n    height: 100%;\n    display: block;\n    top: 0;\n    border-radius: 3px;\n}\n.leftt{\n    margin:auto;\n   \n}\n.container-six {\n    display: grid;\n    grid-template-columns: repeat(5,1fr);\n    /* justify-content: space-around;\n    flex-wrap: wrap; */\n    margin-bottom: 50px;\n}\n\n.box-six {\n    flex-basis: 22%;\n    text-align: center;\n    margin: 5px;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n}\n\n.logo-six {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 10px;\n}\n.box-six:hover{\n    transform: scale(1.03) ;\n    transition: transform 0.2s;\n    background-color: whitesmoke;\n}\n\n.name {\n    font-size: 16px;\n}\n/* Add these styles to your CSS file */\n\n.popup-box {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #fff;\n    padding: 20px;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    text-align: center;\n}\n@media(max-width:'600px'){\n    .popup-box {\n        padding-left: 0px;\n        padding-right: 0px;\n        width:100%\n    } \n}\n\n.popup-logo {\n    width: 100px;\n    /* Adjust the width as needed */\n    height: 100px;\n    /* Adjust the height as needed */\n    margin-bottom: 10px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Style for the email input */\n.popup-box input {\n    /* width: 90%; */\n    padding: 10px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n/* Style for the subscribe button */\n.popup-box button {\n    padding: 10px 20px;\n    background-color: orange;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    margin-top: 10px;\n    cursor: pointer;\n}\n.close-icon {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 20px;\n    cursor: pointer;\n    color: #333;\n}\n@media (max-width: 1000px) {\n    .left-6{\n        width: 100%;\n    }\n}\n@media (max-width: 900px) {\n    .container-six{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width: 500px){\n    .container-six{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width: 350px) {\n    .container-six{\n        grid-template-columns: repeat(1,1fr);\n    }\n}\n\n.popup-wrapper {\n    position: fixed; /* Make the wrapper fixed so it stays in place */\n    bottom: -150px; /* Position it at the bottom of the screen */\n    left: 0; /* Align it to the left edge */\n    width: 100%; /* Make sure it spans the full width of the screen */\n    display: flex; /* Center the popup horizontally */\n    justify-content: center; /* Center horizontally */\n    align-items: baseline;\n  }\n  \n  .popup-box {\n    position: relative; /* Position relative within the wrapper */\n    background: white; /* Ensure background is white or appropriate */\n    border-radius: 8px; /* Optional: add some border radius for styling */\n    padding: 20px; /* Adjust padding as needed */\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* Optional: add shadow for better visibility */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
